import React, { useState, useEffect } from 'react'
import { chunk, filter } from 'lodash' 
import styled from 'styled-components';
import useWindowDimensions from '../hooks/WindowDimensionsHook';
import BlogPreview from './BlogPreview';
import { useNavigate } from 'react-router-dom';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-top: 50px;
  margin-bottom: 50px;
`

const BlogsGrid = ({blogsObjectArray}) => {
  const navigate = useNavigate();
  const {width} = useWindowDimensions();
  const [maxColumnAmount, setMaxColumnAmount] = useState(3);

  useEffect(() => {
    if (width < 600) {
      setMaxColumnAmount(1);
    }
    else if (width < 900) {
      setMaxColumnAmount(2);
    }
    else {
      setMaxColumnAmount(3);
    }
  }, [width])

  const rows = chunk(blogsObjectArray, maxColumnAmount);

  return (
    <div>
      {rows.map((row) => (
        <Row>
          {row.map((blogObj) => (
            <BlogPreview
              title={blogObj.country}
              undertext={blogObj.title}
              relativePathImg={blogObj.mainImagePath}
              onClick={() => navigate(`/blogs/${blogObj.id}`)}
              width={`${(100/(maxColumnAmount+1))}vw`}
              height={`${(100/(maxColumnAmount+1))}vw`}
            />
          ))}
        </Row>
      ))}
    </div>
  )
}

export default BlogsGrid